import { Flex, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

import { COLOR_SCHEMES } from 'packages/common-frontend/theme';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { ComponentGridRenderer } from '~/core/routes/dev/ComponentGridRenderer';
import { PageTemplate } from '~/core/routes/dev/PageTemplate';
import { Typography } from '~/packages/common-frontend/components/Typography';

// Constants
const COMPONENT_NAME = './common-frontend/Typography';

// Fragments
const RouteBase = () => {
  const borderColor = useColorModeValue('gray.100', 'gray.900');
  return (
    <PageTemplate title={COMPONENT_NAME}>
      <Typography variant="section-title" trim>
        Headings
      </Typography>
      <ComponentGridRenderer
        primaries={['page-title', 'section-title', 'section-subtitle'] as const}
        primaryPropName="variant"
        secondaries={[true, false] as const}
        secondaryPropName="trim"
        tertiaries={[null]}
        width="40rem"
      >
        {({ primary: variant, secondary: trim }) => (
          <Flex
            direction="column"
            flexGrow={0}
            width="100%"
            gap="0.5rem"
            border="1rem solid"
            borderColor={borderColor}
          >
            <Typography variant={variant} trim={trim}>
              Credit Agreements Overview
            </Typography>
          </Flex>
        )}
      </ComponentGridRenderer>
      <Typography variant="section-title" trim>
        Paragraphs
      </Typography>
      <ComponentGridRenderer
        primaries={['base', 'base-muted', 'detail', 'detail-muted'] as const}
        primaryPropName="variant"
        secondaries={COLOR_SCHEMES}
        secondaryPropName="colorScheme"
        tertiaries={[null]}
        width="20rem"
      >
        {({ primary: variant, secondary: colorScheme }) => (
          <Flex
            direction="column"
            flexGrow={0}
            width="100%"
            gap="0.5rem"
            border="1rem solid"
            borderColor={borderColor}
          >
            <Typography variant={variant} colorScheme={colorScheme}>
              Aliqua tempor esse ex excepteur esse magna sit laboris veniam
              cupidatat qui dolore tempor.
            </Typography>
          </Flex>
        )}
      </ComponentGridRenderer>
    </PageTemplate>
  );
};
// Exports
export const Route = () => (
  <RouteErrorBoundary
    resetAfterCatch={false}
    fallback={({ message, showErrorToast }) => {
      showErrorToast(message);
      return <div>Uh oh</div>;
    }}
  >
    <RouteBase />
  </RouteErrorBoundary>
);
